import React, { useContext } from "react";
import { Layout, Menu } from "antd";
import {
  HomeOutlined,
  MoreOutlined,
  UserOutlined,
  LogoutOutlined,
  HolderOutlined,
  QuestionOutlined,
  StopOutlined
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import logo from "../assets/logo-full.png";
import mini from "../assets/logo-mini.png";

const { Sider } = Layout;

const CustomSidebar = () => {
  const { isDark, logout, collapsed, hasSettingsAccess } =
    useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();

  let menuItems = [
    { key: "/", icon: <HomeOutlined />, label: "Inicio" },
    { key: "/principal", icon: <MoreOutlined />, label: "Menú Principal" },
    {
      key: "/secundario",
      icon: <HolderOutlined />,
      label: "Menú Secundario"
    },
    { key: "/preguntas", icon: <QuestionOutlined />, label: "Preguntas" },
    {
      key: "/rechazo-servicio",
      icon: <StopOutlined />,
      label: "Rechazo - Servicios"
    },
    {
      key: "/rechazo-comercial",
      icon: <StopOutlined />,
      label: "Rechazo - Fuerza Comercial"
    }
  ];

  if (hasSettingsAccess) {
    menuItems.push(
      { type: "divider" },
      {
        key: "/usuarios",
        icon: <UserOutlined />,
        label: "Gestionar usuarios"
      }
    );
  }

  menuItems.push(
    { type: "divider" },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Cerrar Sesión"
    }
  );

  const handleMenuClick = ({ key }) => {
    if (key === "logout") {
      logout();
      navigate("/login", { replace: true });
    } else {
      navigate(key);
    }
  };

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      width={260}
      theme={isDark ? "dark" : "light"}
      style={{
        borderRight: isDark ? "none" : "1px solid #64A70A",
        height: "100vh"
      }}
    >
      <div
        style={{
          height: 64,
          display: "flex",
          alignItems: "center",
          padding: "0 24px",
          fontSize: "18px",
          fontWeight: 700,
          letterSpacing: "-0.5px",
          color: isDark ? "#fff" : "#000"
        }}
      >
        {!collapsed ? (
          <span style={{ marginLeft: 12, fontWeight: 700 }}>
            <img style={{ width: 180 }} src={logo} alt="light" />
          </span>
        ) : (
          <span style={{ marginLeft: -5 }}>
            <img style={{ width: 40 }} src={mini} alt="light" />
          </span>
        )}
      </div>
      <Menu
        mode="inline"
        selectedKeys={[location.pathname]}
        style={{
          borderRight: 0,
          padding: "0 8px",
          marginTop: "16px"
        }}
        inlineIndent={12}
        items={menuItems}
        onClick={handleMenuClick}
      />
    </Sider>
  );
};

export default CustomSidebar;
